import { IAction, isType } from '@zaibot/fsa';
import { IUser } from './types';

import AUTHENTICATED from './actions/AUTHENTICATED';
import LOGGEDOUT from './actions/LOGGEDOUT';
import ACCOUNDMANAGER from './actions/ACCOUNDMANAGER';

interface IState {
  accessToken: string;
  user: IUser & any;
  accountmanager: boolean;
}

export const selector = (state: any) => state.auth as IState;

export default (state: IState = { accessToken: null, user: {}, accountmanager:false }, action: IAction) => {
    if (isType(action, LOGGEDOUT)) {
        return { ...state, accessToken: null, user: {} };
    }
    if (isType(action, AUTHENTICATED)) {
        return { ...state, accessToken: action.payload.token, user: action.payload.user };
    }
    if (isType(action, ACCOUNDMANAGER)) {
        return { ...state, accountmanager: action.payload.accountmanager };
    }    
    return state;
};



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/auth/reducer.tsx